export default "__VITE_ASSET__CRXlm0Po__"